<template>
	<div>
		<div class="venn-legend">
			<div class="venn-legend-item">
				<div class="venn-legend-item-circle" :style="{backgroundColor: store.chartColourGroup[0]}"></div>
				<div>
					<div class="venn-legend-item-label">{{venntotals[0].name}}</div>
					<div class="venn-legend-val">{{venntotals[0].val}}%</div>
				</div>
			</div>
			<div class="venn-legend-item">
				<div class="venn-legend-item-circle" :style="{backgroundColor: store.chartColourGroup[1]}"></div>
				<div>
					<div class="venn-legend-item-label">{{venntotals[1].name}}</div>
					<div class="venn-legend-val">{{venntotals[1].val}}%</div>
				</div>
			</div>
<!--			<div class="venn-legend-item">-->
<!--				<div class="venn-legend-item-circle" :style="{backgroundColor: store.chartColourGroup[2]}"></div>-->
<!--				<div>-->
<!--					<div class="venn-legend-item-label">{{venndata.data[2].name}}</div>-->
<!--					<div class="venn-legend-val">{{venndata.data[2].dp.pct}}%</div>-->
<!--				</div>-->
<!--			</div>-->
		</div>
		<div>
			<ChartJSVenn :chartdata="chartjsdata"></ChartJSVenn>
<!--			<highcharts :options="highchartsOptions"></highcharts>-->
		</div>
	</div>
</template>

<script>
import {store} from '@/store.js'
import {globalMixin} from "@/mixins"
// import { Chart } from 'highcharts-vue'
import ChartJSVenn from "@/components/charts/ChartJSVenn.vue";
export default {
	name: 'VennCompareTwo',
	mixins: [globalMixin],
	components: {
		ChartJSVenn,
		// highcharts: Chart,
	},
	props: {
		venndata: {
			type: Object,
			default: null,
		},
		venntotals: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			store: store,

			// highchartsOptions: {
			// 	title: {
			// 		text: ''
			// 	},
			// 	exporting: {
			// 		enabled: false,
			// 	},
			// 	series: [{
			// 		type: 'venn',
			// 		name: '',
			// 		data: [],
			// 	}],
			// 	credits: {
			// 		enabled: false,
			// 	},
			// 	legend: {
			// 		enabled: true,
			// 		labelFormat: '{name}',
			// 	},
			// 	chart: {
			// 		height: '550px',
			// 		// animation: false,
			// 	},
			// 	colors: [],
			// 	pane: {
			// 		size: '100%',
			// 	},
			// 	plotOptions: {
			// 		series: {
			// 			// animation: false,
			// 		},
			// 		venn: {
			// 			keys: [], //having this set to blank removes change animation but solves the euler diagram crash
			// 			tooltip: {
			// 				pointFormat: '{point.sets}: <b>{point.value}</b>',
			// 			},
			// 			dataLabels: {
			// 				enabled: true,
			// 				format: '{point.value}%',
			// 				style: {
			// 					textOutline: false,
			// 					fontWeight: 'bold',
			// 					fontSize: '22px',
			// 				},
			// 			},
			// 			showInLegend: false,
			// 		},
			// 	},
			// },

			chartjsdata: null,
		}
	},
	computed: {

	},
	methods: {
		prepData() {
			this.chartjsdata = this.venndata.data
			// this.highchartsOptions.colors = this.store.chartColourGroup
			// let d = []
			// for(let di of this.venndata.data) {
			// 	let nmarr = di.name.split(' & ')
			// 	let val = di.dp.pct
			// 	d.push({
			// 		sets: nmarr,
			// 		value: val,
			// 	})
			// }
			// this.highchartsOptions.series[0].data = d
			// if(this.venndata.seriesNames) this.highchartsOptions.series[0].name = this.venndata.seriesNames[0]
			// if(this.venndata.chartTitle) this.highchartsOptions.title.text = this.venndata.chartTitle
		},
	},
	watch: {
		venndata() {
			if(this.venndata) this.prepData()
		},
	},
	mounted() {
		if(this.venndata) this.prepData()
	},
	created() {

	},
}
</script>

<style scoped>
.venn-legend {
	display: flex;
	justify-content: center;
	gap: 30px;
}
.venn-legend-item {
	display: flex;
	align-items: center;
}
.venn-legend-item-label {
	font-weight: bold;
	margin-bottom: 5px;
	font-size: 16px;
}
.venn-legend-val {
	font-size: 18px;
}
.venn-legend-item-circle {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	display: inline-block;
	margin-right: 10px;
}
</style>
